<template>
  <div class="slide-game">
    <div class="main-title">使用帮助/互动游戏/划一划游戏</div>
    <h1 class="page-title">划一划游戏</h1>
    <h4 class="content-text">
      通过划动手机屏幕来累计比分，最终展示总排名的互动游戏。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-slideGame1_1768291759911d1713d.webp"
      alt="松鼠酒吧大屏互动划一划数钞票游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （数钞票）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-slideGame2_17682917599113b3c7d.webp"
      alt="松鼠酒吧大屏互动划一划射手王踢足球游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （谁是射手王）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-slideGame3_1768291759911ca32b9.webp"
      alt="松鼠酒吧大屏互动划一划切水果游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （切水果）
    </h4>
  </div>
</template>

<script>
export default {
  name: 'SlideGame',
};
</script>

<style lang="less" scoped>
.slide-game {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.center {
  text-align: center;
  margin-top: 0;
}
</style>
